module.exports = __webpack_public_path__ + "static/scale-model-of-sibley-nature-center-in-midland-texas-4e62f755a1107e0f2b5d6777751509c7.png";